import React from 'react'
import Dashboard from '../../Components/Doctor/Dashboard/Dashboard'

const DoctorDashboardPage = () => {
  return (
    <div className='p-5'>
      <Dashboard/>
    </div>
  )
}

export default DoctorDashboardPage